// @mui material components
import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import { Link, useLocation, useNavigate } from "react-router-dom";
// Dreamer Admin Panel Dashboard React components
import SoftBox from "components/SoftBox";
import CircularProgress from "@mui/material/CircularProgress"; // Import CircularProgress for loading spinner
// Dreamer Admin Panel Dashboard React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import MiniStatisticsCard from "examples/Cards/StatisticsCards/MiniStatisticsCard";
import { Box, Card, Switch } from "@mui/material";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import { UserDetail } from "model/userDetailResponseModel";
import api from "api/api";
import user from "assets/images/illustrations/user.png";
import curved0 from "assets/images/curved-images/curved0.jpg";
import { ApiResponse } from "model/apiResponseModel";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SoftAvatar from "components/SoftAvatar";
import SoftBadge from "components/SoftBadge";
import Table from "examples/Tables/Table";
import { ProjectModel } from "model/projectListModel";
import { convertSecondsToHoursLive } from "helpers/logMessages";
import { RxTextAlignRight } from "react-icons/rx";
import ConfirmDialog from "layouts/leaderboard/components/ConfirmDialog";
import IssueRewardDialog from "layouts/singleuser/components/issue-reward-dialog";


function SingleUser() {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const [totalProjects, setTotalProjects] = useState(0);
  const [completedProjects, setCompletedProjects] = useState(0);
  const [notStartedProjects, setNotStartedProjects] = useState(0);
  const [onGoingProjects, setOnGoingProjects] = useState(0);
  const [subId, setSubId] = useState("");
  const [purchasedOn, setPurchasedOn] = useState("");
  const [expiryTime, setExpiryTime] = useState("---");
  const [billing, setBilling] = useState("");
  const [amount, setAmount] = useState("");
  const [interval, setInterval] = useState("");
  const [intervalCount, setIntervalCount] = useState("");
  const [currency, setCurrency] = useState("");
  const [project_status, setProjectStatus] = useState("not_started");
  const [status, setStatus] = useState("---");
  const [isSubscribed, setIsSubscribed] = useState("");
  const [isVip, setIsVip] = useState(false);
  const [profilePic, setProfilePic] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  // const [isDeletionLoading, setIsDeletionLoading] = useState(false);
  const [insidePageLoading, setInsidePageLoading] = useState(true);
  const [noUiText, setNoUiText] = useState(true);
  const [activeTab, setActiveTab] = useState("projects");

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    isLoading: false,
    type: null,
  });
  const [rewardColumns, setRewardColumns] = useState([]);
  const [rewardRows, setRewardRows] = useState([]);
  const [rewardsLoading, setRewardsLoading] = useState(false);
  const [issueRewardDialogOpen, setIssueRewardDialogOpen] = useState(false);
  const [isIssuingReward, setIsIssuingReward] = useState(false);

  const deleteUser = () => {
    // setIsDeletionLoading(true)
    setConfirmDialog({
      isOpen: true,
      isLoading: false,
    });
  };

  const handleCloseDialog = () => {
    setConfirmDialog((prev) => ({ ...prev, isOpen: false }));
  };

  const handleConfirmDialog = async () => {
    try {
      setConfirmDialog((prev) => ({ ...prev, isLoading: true }));

      const data = {
        user_id: userId
      };
      let response = await api.deleteUser(data);
      const apiResponse = new ApiResponse(response.status, response.message);

      if (apiResponse.status === 1) {
        alert(apiResponse.message);
        window.location.href = '/users';
      } else {
        alert(apiResponse.message);
      }

    } catch (error) {
      console.error("Error deleting user:", error);
    } finally {
      setConfirmDialog((prev) => ({ ...prev, isOpen: false, isLoading: false }));
    }
  };

  const navigate = useNavigate();
  const handleTypeClick = async (type) => {
    setProjectStatus(type);
    if (type === "completed") {
      setNoUiText("Currently, user don't have any completed projects.");
    } else if (type === "ongoing") {
      setNoUiText("Currently, user don't have any projects in progress.");
    } else {
      setNoUiText("Currently, user don't have any projects started.");
    }
    await fetchProjects(type);
  };
  const handleSetIsActive = () => setIsActive(!isActive);
  const handleSetIsVip = () => setIsVip(!isVip);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const userId = queryParams.get("userId");

  const handleUpdate = async (e) => {
    e.preventDefault();
    const isDeleted = !isActive;
    try {
      const data = {
        user_id: userId,
        email: email,
        name: name,
        isVip: isVip.toString(),
        isActive: isDeleted.toString()
      };

      const response = await api.updateUserDetail(data);
      const apiResponse = new ApiResponse(response.status, response.message);

      if (apiResponse.status === 1) {
        alert(apiResponse.message);
      } else {
        alert(apiResponse.message);
      }
    } catch (error) {
      console.error("Error fetching user:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchProjects = async (project_status) => {
    try {
      // console.log(project_status);
      setInsidePageLoading(true);
      let postData = {};
      if (userId && userId != "") {
        postData = {
          userId,
          project_status
        };
      };

      const response = await api.getProjectsList(postData);
      const apiResponse = new ApiResponse(response.status, response.message);

      if (apiResponse.status === 1) {
        const projectModelData = new ProjectModel(response.data);
        setColumns([
          { name: "project", align: "left" },
          { name: "design", align: "center" },
          { name: "artist", align: "center" },
          { name: "brand", align: "center" },
          { name: "loggedTime", align: "center" },
          { name: "created", align: "center" },
          { name: "view", align: "center" },
          { name: "status", align: "center" },
        ]);
        setRows(
          projectModelData.projects.map((project) => ({
            linkPath: `/project-detail?projectId=${project._id}`,
            project: (
              <SoftBox display="flex" alignItems="center" px={1} py={0.5}>
                <SoftAvatar src={project.image[0] || userImage} alt={project.name} size="sm" variant="rounded" />
                <SoftBox display="flex" flexDirection="column" ml={2}>
                  <SoftTypography variant="button" fontWeight="medium">
                    {project.name}
                  </SoftTypography>
                  <SoftTypography variant="caption" color="secondary">
                    {project.email}
                  </SoftTypography>
                </SoftBox>
              </SoftBox>
            ),
            design: (
              <SoftTypography variant="caption" color="secondary" fontWeight="medium">
                {project.design}
              </SoftTypography>
            ),
            artist: (
              <SoftTypography variant="caption" color="secondary" fontWeight="medium">
                {project.artist}
              </SoftTypography>
            ),
            brand: (
              <SoftTypography variant="caption" color="secondary" fontWeight="medium">
                {project.brand}
              </SoftTypography>
            ),
            loggedTime: (
              <SoftTypography variant="caption" color="secondary" fontWeight="medium">
                {convertSecondsToHoursLive(project.totalDuration)}
              </SoftTypography>
            ),
            created: (
              <SoftTypography variant="caption" color="secondary" fontWeight="medium">
                {new Date(project.created_at * 1000).toLocaleDateString()}

              </SoftTypography>
            ),
            view: (
              <SoftTypography
                component={Link}
                to={`/project-detail?projectId=${project._id}`}
                variant="caption"
                color="secondary"
                fontWeight="medium"
              >
                View
              </SoftTypography>
            ),
            status: (
              <SoftBadge
                variant="gradient"
                badgeContent={
                  project.project_status === "not_started"
                    ? "Not Started"
                    : project.project_status === "ongoing"
                      ? "Ongoing"
                      : "Completed"
                }
                color={
                  project.project_status === "not_started"
                    ? "error"
                    : project.project_status === "ongoing"
                      ? "warning"
                      : "success"
                }
                size="xs"
              />
            ),
          }))
        );
        // setTotalPages(response.totalPages);
      } else {
        alert(apiResponse.message);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setIsLoading(false);
      setInsidePageLoading(false);
    }
  };

  const getRewardStatusColor = (rewardStatus) => {
    if (rewardStatus === "available" || rewardStatus === "active") return "success";
    if (rewardStatus === "expired" || rewardStatus === "used") return "error";
    return "warning";
  };

  const fetchUserRewards = async () => {
    if (!userId) return;

    try {
      setRewardsLoading(true);
      const response = await api.getUserRewards({ userId });
      const apiResponse = new ApiResponse(response.status, response.message);

      if (apiResponse.status === 1) {
        const rewards = response.data?.rewards || [];
        setRewardColumns([
          { name: "title", align: "left" },
          { name: "category", align: "center" },
          { name: "description", align: "center" },
          { name: "status", align: "center" },
        ]);
        setRewardRows(
          rewards.map((reward) => ({
            title: (
              <SoftBox display="flex" alignItems="center" px={1} py={0.5}>
                {reward.main_icon && (
                  <SoftAvatar src={reward.main_icon} alt={reward.name} size="sm" variant="rounded" />
                )}
                <SoftBox display="flex" flexDirection="column" ml={reward.main_icon ? 2 : 0}>
                  <SoftTypography variant="button" fontWeight="medium">
                    {reward.name}
                  </SoftTypography>
                </SoftBox>
              </SoftBox>
            ),
            category: (
              <SoftTypography variant="caption" color="secondary" fontWeight="medium" textTransform="capitalize">
                {reward.category}
              </SoftTypography>
            ),
            description: (
              <SoftTypography variant="caption" color="secondary" fontWeight="medium">
                {reward.description}
              </SoftTypography>
            ),
            status: (
              <SoftBadge
                variant="gradient"
                badgeContent={reward.status}
                color={getRewardStatusColor(reward.status)}
                size="xs"
              />
            ),
          }))
        );
      } else {
        alert(apiResponse.message);
        setRewardRows([]);
      }
    } catch (error) {
      console.error("Error fetching user rewards:", error);
      setRewardRows([]);
    } finally {
      setRewardsLoading(false);
    }
  };

  const handleIssueReward = async (rewardData) => {
    const payload = {
      userId,
      rewardId: rewardData.rewardId,
      benefits: rewardData.benefits,
      expiry_at: rewardData.expiry_at,
    };

    if (!payload.userId || !payload.rewardId || !payload.benefits?.length || !payload.expiry_at) {
      alert("Please fill in all required fields.");
      return { success: false, message: "Missing required reward fields" };
    }

    try {
      setIsIssuingReward(true);
      const response = await api.issueReward(payload);
      const apiResponse = new ApiResponse(response.status, response.message);

      if (apiResponse.status === 1) {
        alert(apiResponse.message);
        await fetchUserRewards();
        return { success: true, message: apiResponse.message };
      }

      alert(apiResponse.message);
      return { success: false, message: apiResponse.message };
    } catch (error) {
      console.error("Error issuing reward:", error);
      alert("Failed to issue reward");
      return { success: false, message: "Failed to issue reward" };
    } finally {
      setIsIssuingReward(false);
    }
  };

  useEffect(() => {
    if (activeTab === "rewards" && userId) {
      fetchUserRewards();
    }
  }, [activeTab, userId]);

  useEffect(() => {
    const loginData = JSON.parse(localStorage.getItem("loginData") || sessionStorage.getItem("loginData"));
    if (!loginData) {
      navigate('/authentication/sign-in');
      return;
    }
    const fetchUserDetail = async () => {
      try {
        const userData = { user_id: userId };
        const response = await api.getUserDetail(userData);
        const apiResponse = new ApiResponse(response.status, response.message);

        if (apiResponse.status === 1) {
          const userDetail = new UserDetail(response.data);
          setEmail(userDetail.email);
          setName(userDetail.name);
          setIsActive(!userDetail.is_deleted);
          setTotalProjects(userDetail.totalprojectCount);
          setCompletedProjects(userDetail.completedProjectCount);
          setNotStartedProjects(userDetail.notStartedProjectCount);
          setOnGoingProjects(userDetail.onGoingProjectCount);
          setSubId(userDetail.sub_id)
          setProfilePic(userDetail.profile_picture)
          setPurchasedOn(userDetail.purchased_on)
          setExpiryTime(userDetail.expiry_time != "" ? userDetail.expiry_time : "---")
          setBilling(userDetail.billing)
          setAmount(userDetail.amount)
          setInterval(userDetail.interval)
          setIntervalCount(userDetail.intervalCount)
          setCurrency(userDetail.currency)
          console.log("here");
          console.log(userDetail);
          if (userDetail.isVip === "true") {
            console.log("heretruecase");
            setIsVip(true);
          } else {
            console.log("herefalsecase");
            setIsVip(false);
          }
          setStatus(userDetail.status != "" ? userDetail.status : "---")
          setIsSubscribed(userDetail.isSubscribed)
          fetchProjects(project_status)
        } else {
          alert(apiResponse.message);
        }
      } catch (error) {
        console.error("Error fetching user:", error);
      }
    };

    fetchUserDetail();
  }, [userId, navigate]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {/* {isDeletionLoading && ( */}

      <ConfirmDialog
        isOpen={confirmDialog.isOpen}
        handleClose={handleCloseDialog}
        handleConfirm={handleConfirmDialog}
        isLoading={confirmDialog.isLoading}
        title={
          "Are you sure you want to delete this user and its projects permanently?"
        }
        actionText={"Yes, Delete"}
      />

      <IssueRewardDialog
        open={issueRewardDialogOpen}
        onClose={() => setIssueRewardDialogOpen(false)}
        onSubmit={handleIssueReward}
        loading={isIssuingReward}
      />

      {/* )} */}
      {isLoading ? (
        // Show loading spinner while data is loading
        <SoftBox display="flex" justifyContent="center" alignItems="center" height="100vh">
          <CircularProgress />
        </SoftBox>
      ) : (
        // Main content when data is loaded
        <>
          {/* <SoftBox
        display="flex"
        alignItems="center"
        position="relative"
        minHeight="18.75rem"
        borderRadius="xl"
        sx={{
          backgroundImage: ({ functions: { rgba, linearGradient }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.info.main, 0.6),
              rgba(gradients.info.state, 0.6)
            )}, url(${curved0})`,
          backgroundSize: "cover",
          backgroundPosition: "50%",
          overflow: "hidden",
        }}
      /> */}
          <SoftBox mt={5} mb={3}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} xl={3}>
                <MiniStatisticsCard
                  title={{ text: "Total Projects" }}
                  count={totalProjects.toString()}
                  icon={{ color: "info", component: "summarize" }}
                />
              </Grid>
              <Grid item xs={12} sm={6} xl={3}>
                <Box
                  onClick={() => handleTypeClick("completed")}
                  sx={{
                    cursor: "pointer",

                  }}
                >
                  <MiniStatisticsCard
                    title={{ text: "Completed Projects" }}
                    count={completedProjects.toString()}
                    icon={{ color: "info", component: "check_circle" }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} xl={3}>
                <Box
                  onClick={() => handleTypeClick("ongoing")}
                  sx={{
                    cursor: "pointer",

                  }}
                >
                  <MiniStatisticsCard
                    title={{ text: "On Going Projects" }}
                    count={onGoingProjects.toString()}
                    icon={{ color: "info", component: "autorenew" }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} xl={3}>
                <Box
                  onClick={() => handleTypeClick("not_started")}
                  sx={{
                    cursor: "pointer",

                  }}
                >
                  <MiniStatisticsCard
                    title={{ text: "Not Started" }}
                    count={notStartedProjects.toString()}
                    icon={{ color: "info", component: "hourglass_empty" }}
                  />
                </Box>
              </Grid>
            </Grid>
          </SoftBox>

          <SoftBox mb={3}>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={7}>
                <Card sx={{ height: "100%", p: 4 }}>
                  <SoftBox component="form" role="form" onSubmit={handleUpdate}>
                    <SoftBox mb={2}>
                      <SoftBox mb={1} ml={0.5}>
                        <SoftTypography component="label" variant="caption" fontWeight="bold">
                          Email
                        </SoftTypography>
                      </SoftBox>
                      <SoftInput
                        type="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </SoftBox>
                    <SoftBox mb={2}>
                      <SoftBox mb={1} ml={0.5}>
                        <SoftTypography component="label" variant="caption" fontWeight="bold">
                          Name
                        </SoftTypography>
                      </SoftBox>
                      <SoftInput
                        type="text"
                        placeholder="Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </SoftBox>
                    <SoftBox display="flex" alignItems="center">
                      <Switch checked={isActive} onChange={handleSetIsActive} />
                      <SoftTypography
                        variant="button"
                        fontWeight="regular"
                        onClick={handleSetIsActive}
                        style={{ marginRight: "10px" }}
                        sx={{ cursor: "pointer", userSelect: "none" }}
                      >
                        &nbsp;&nbsp;Is Active
                      </SoftTypography>
                      <Switch checked={isVip} onChange={handleSetIsVip} />
                      <SoftTypography
                        variant="button"
                        fontWeight="regular"
                        onClick={handleSetIsVip}
                        sx={{ cursor: "pointer", userSelect: "none" }}
                      >
                        &nbsp;&nbsp;Is Vip
                      </SoftTypography>
                      {/* <SoftBox> */}
                      <SoftButton
                        sx={{ cursor: "pointer", userSelect: "none", ml: "auto" }}
                        variant="contained"
                        size="medium"
                        color="error"
                        onClick={deleteUser}
                      >
                        Delete User
                      </SoftButton>

                      {/* </SoftBox> */}
                    </SoftBox>
                    {isSubscribed === "true" && isVip === "false" && (

                      <SoftBox mb={2}>
                        <SoftBox mb={1} ml={0.5}>
                          <SoftTypography component="label" variant="caption" fontWeight="bold">
                            Subscription Detail
                          </SoftTypography>
                          <SoftBox
                            component="li"
                            display="flex"
                            justifyContent="space-between"
                            alignItems="flex-start"
                            bgColor="grey-100"
                            borderRadius="lg"
                            p={3}
                            mt={2}
                          >
                            <SoftBox width="100%" display="flex" flexDirection="column">
                              <SoftBox
                                display="flex"
                                justifyContent="space-between"
                                alignItems={{ xs: "flex-start", sm: "center" }}
                                flexDirection={{ xs: "column", sm: "row" }}
                                mb={2}>
                                <SoftTypography variant="button" fontWeight="medium" textTransform="capitalize">
                                  Subscription Id: #{subId}
                                </SoftTypography>
                              </SoftBox>
                              <SoftBox mb={1} lineHeight={0}>
                                <SoftTypography variant="caption" color="text">
                                  <SoftTypography variant="caption" fontWeight="medium" textTransform="capitalize">
                                    {isSubscribed == "true" ? "Premium" : "Basic"}
                                  </SoftTypography>
                                </SoftTypography>
                              </SoftBox>
                              <SoftBox mb={1} lineHeight={0}>
                                <SoftTypography variant="caption" color="text">
                                  Interval:&nbsp;&nbsp;&nbsp;
                                  <SoftTypography variant="caption" fontWeight="medium" textTransform="capitalize">
                                    {isSubscribed == "true" ? currency + " " + amount + "/" + interval : "---"}
                                  </SoftTypography>
                                </SoftTypography>
                              </SoftBox>
                              <SoftBox mb={1} lineHeight={0}>
                                <SoftTypography variant="caption" color="text">
                                  Current Status:&nbsp;&nbsp;&nbsp;
                                  <SoftTypography variant="caption" fontWeight="medium">
                                    {status}
                                  </SoftTypography>
                                </SoftTypography>
                              </SoftBox>
                              <SoftTypography variant="caption" color="text">
                                Expiry Date:&nbsp;&nbsp;&nbsp;
                                <SoftTypography variant="caption" fontWeight="medium">
                                  {expiryTime}
                                </SoftTypography>
                              </SoftTypography>
                            </SoftBox>
                          </SoftBox>
                        </SoftBox>
                      </SoftBox>
                    )}
                    <SoftBox mt={4} mb={1}>
                      <SoftButton type="submit" variant="gradient" color="info" fullWidth>
                        Update
                      </SoftButton>
                    </SoftBox>
                  </SoftBox>
                </Card>
              </Grid>
              <Grid item xs={12} lg={5}>
                <SoftBox
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  pt={3}
                  height="100%">
                  <SoftBox
                    component="img"
                    src={profilePic === "" ? user : profilePic}
                    alt="rocket"
                    width="200px" />
                </SoftBox>
              </Grid>
            </Grid>
          </SoftBox>
          <SoftBox display="flex" gap={2} mb={3} px={2}>
            <SoftBox
              onClick={() => setActiveTab("projects")}
              sx={{
                cursor: "pointer",
                px: 3,
                py: 0.5,
                borderRadius: "50px",
                border: "1px solid #4B319D",
                backgroundColor: activeTab === "projects" ? "#523a92" : "transparent",
                color: activeTab === "projects" ? "#FFFFFF" : "#523a92",
                fontWeight: "bold",
                fontSize: "14px",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: activeTab === "projects" ? "#523a92" : "rgba(75, 49, 157, 0.1)",
                },
              }}
            >
              Projects
            </SoftBox>
            <SoftBox
              onClick={() => setActiveTab("rewards")}
              sx={{
                cursor: "pointer",
                px: 3,
                py: 0.5,
                borderRadius: "50px",
                border: "1px solid #4B319D",
                backgroundColor: activeTab === "rewards" ? "#523a92" : "transparent",
                color: activeTab === "rewards" ? "#FFFFFF" : "#523a92",
                fontWeight: "bold",
                fontSize: "14px",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: activeTab === "rewards" ? "#523a92" : "rgba(75, 49, 157, 0.1)",
                },
              }}
            >
              Rewards
            </SoftBox>
          </SoftBox>
          <SoftBox py={3}>
            {activeTab === "projects" ? (
            <SoftBox mb={3}>
              <Card>
                <SoftBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
                  <SoftBox display="flex" alignItems="center" justifyContent="space-between" width="100%" gap={1}>
                    <SoftTypography variant="h6">Projects</SoftTypography>

                <SoftBox className="button_group_dashboard" display="flex" alignItems="center" justifyContent="end" gap={2} sx={{ mb: 0 }}>
                  <SoftBox
                    onClick={() => handleTypeClick("completed")}
                    sx={{
                      cursor: "pointer", 
                      px: 2,
                      py: 0.5,
                      borderRadius: "50px",
                      border: "1px solid #4B319D",
                      backgroundColor: project_status === "completed" ? "#523a92" : "transparent",
                      color: project_status === "completed" ? "#FFFFFF" : "#523a92",
                      transition: "all 0.3s ease",
                      fontSize: "0.875rem",
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      minWidth: "100px",
                      "&:hover": {
                        backgroundColor: project_status === "completed" ? "#523a92" : "rgba(75, 49, 157, 0.1)",
                      },
                    }}
                  >
                    Completed
                  </SoftBox>
                  <SoftBox
                    onClick={() => handleTypeClick("ongoing")}
                    sx={{
                      cursor: "pointer",
                      px: 2,
                      py: 0.5,
                      borderRadius: "50px",
                      border: "1px solid #4B319D",
                      backgroundColor: project_status === "ongoing" ? "#523a92" : "transparent",
                      color: project_status === "ongoing" ? "#FFFFFF" : "#523a92",
                      transition: "all 0.3s ease",
                      fontSize: "0.875rem",
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      minWidth: "100px",
                      "&:hover": {
                        backgroundColor: project_status === "ongoing" ? "#523a92" : "rgba(75, 49, 157, 0.1)",
                      },
                    }}
                  >
                    In Progress
                  </SoftBox>
                  <SoftBox
                    onClick={() => handleTypeClick("not_started")}
                    sx={{
                      cursor: "pointer",
                      px: 2,
                      py: 0.5,
                      borderRadius: "50px",
                      border: "1px solid #4B319D",
                      backgroundColor: project_status === "not_started" ? "#523a92" : "transparent",
                      color: project_status === "not_started" ? "#FFFFFF" : "#523a92",
                      transition: "all 0.3s ease",
                      fontSize: "0.875rem",
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      minWidth: "100px",
                      "&:hover": {
                        backgroundColor: project_status === "not_started" ? "#523a92" : "rgba(75, 49, 157, 0.1)",
                      },
                    }}
                  >
                    Not Started
                  </SoftBox>
                </SoftBox>
                  </SoftBox>
                </SoftBox>
                <SoftBox 
                  sx={{
                    "& .MuiTableRow-root:not(:last-child)": {
                      "& td": {
                        borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                          `${borderWidth[1]} solid ${borderColor}`,
                      },
                    },
                  }}
                >
                  {insidePageLoading ? (
                    <SoftBox display="flex" height="500px" justifyContent="center" alignItems="center" p={3}>
                      <SoftTypography variant="subtitle1" color="textSecondary">
                        Loading...
                      </SoftTypography>
                    </SoftBox>
                  ) : rows.length > 0 ? (
                    <Table columns={columns} rows={rows} />
                  ) : (
                    <SoftBox display="flex" justifyContent="center" alignItems="center" p={3}>
                      <SoftTypography variant="subtitle1" color="textSecondary">
                        {noUiText}
                      </SoftTypography>
                    </SoftBox>
                  )}
                </SoftBox>
              </Card>
            </SoftBox>
            ) : (
            <SoftBox mb={3}>
              <Card>
                <SoftBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
                  <SoftTypography variant="h6">Rewards</SoftTypography>
                  <SoftButton
                    variant="gradient"
                    color="info"
                    size="small"
                    onClick={() => setIssueRewardDialogOpen(true)}
                  >
                    Issue Reward
                  </SoftButton>
                </SoftBox>
                <SoftBox
                  sx={{
                    "& .MuiTableRow-root:not(:last-child)": {
                      "& td": {
                        borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                          `${borderWidth[1]} solid ${borderColor}`,
                      },
                    },
                  }}
                >
                  {rewardsLoading ? (
                    <SoftBox display="flex" height="300px" justifyContent="center" alignItems="center" p={3}>
                      <CircularProgress />
                    </SoftBox>
                  ) : rewardRows.length > 0 ? (
                    <Table columns={rewardColumns} rows={rewardRows} />
                  ) : (
                    <SoftBox display="flex" justifyContent="center" alignItems="center" p={3}>
                      <SoftTypography variant="subtitle1" color="textSecondary">
                        No rewards found for this user.
                      </SoftTypography>
                    </SoftBox>
                  )}
                </SoftBox>
              </Card>
            </SoftBox>
            )}
          </SoftBox>
        </>
      )}
      <Footer />
    </DashboardLayout>
  );
}

export default SingleUser;
